module.exports = __webpack_public_path__ + "static/img/2367_phase_function_Paper_Points.951f1ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2367_phase_function_Paper_Points.png
// module id = CGX4
// module chunks = 0